import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import {
  Command0x01800000,
  Command0x02800000,
  Command0x02A00000,
  Command0x10800000,
  Command0x14900000,
  Command0x14A00000,
  Command0x18800000,
  Command0x20800000,
  Command0x20900000,
  Command0x21800000,
  Command0x22800000,
  Command0x27800000,
  Command0x28800000,
  Command0x28900000,
  Command0x28A00000,
  Command0x2A800000,
  Command0x30800000,
  Command0x31800000,
  Command0x48800000,
  Command0x49800000,
  Command0x50800000,
  CommandDefault,
  CommandNoParams,
} from "./forms";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { Directory } from "../../store/Common/CommonModel";

const forms = {
  1098907648: CommandNoParams,
  1115684864: CommandNoParams,
  1132462080: CommandNoParams,
  1149239296: CommandNoParams,
  142606336: CommandNoParams,
  2155872256: CommandNoParams,
  2172649472: CommandNoParams,
  343932928: CommandNoParams,
  696254464: CommandNoParams,
  281018368: CommandNoParams,
  2961178624: CommandNoParams,
  3028287488: CommandNoParams,
  3078619136: CommandNoParams,
  3212836864: CommandNoParams,
  285736960: CommandNoParams,

  25165824: Command0x01800000,
  41943040: Command0x02800000,
  44040192: Command0x02A00000,
  1216348160: Command0x48800000,
  1233125376: Command0x49800000,
  1350565888: Command0x50800000,
  276824064: Command0x10800000,
  344981504: Command0x14900000,
  346030080: Command0x14A00000,
  545259520: Command0x20800000,
  546308096: Command0x20900000,
  562036736: Command0x21800000,
  662700032: Command0x27800000,
  679477248: Command0x28800000,
  680525824: Command0x28900000,
  681574400: Command0x28A00000,
  713031680: Command0x2A800000,
  411041792: Command0x18800000,
  578813952: Command0x22800000,
  830472192: Command0x31800000,
  // 813694976: Command0x30800000,
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    command: {
      borderSize: 3,
      marginBottom: 15,
    },
    runButton: {
      // marginRight: 10,
    },
    commandHead: {
      backgroundColor: "rgba(0, 0, 0, .1)",
    },
    commandTitle: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(30),
    },
    commandContent: {
      display: "block",
      borderTop: "1px solid rgba(0, 0, 0, 0.12);",
      padding: "5px 20px 15px 20px",
    },
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
    paramsControl: {
      margin: theme.spacing(2),
      marginLeft: 0,
      marginRight: 0,
      padding: "10px 15px",
    },
    paramsTitle: {
      padding: 0,
      margin: "5px 0",
    },
    optionGroup: {
      background: "white",
    },
    chips: {},
    chip: {},
  })
);

interface Props {
  runCommandStartAction: (
    outVersion: number,
    deviceId: number,
    params: string
  ) => void;
  onRequestTemplateDirectory: () => void;
  onRequestDeviceDirectory: () => void;
  commandRunning: boolean;
  templateDirLoading: boolean;
  deviceDirLoading: boolean;
  deviceDirectory: Directory[];
  templateDirectory: Directory[];
}

const isJsonObject = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  if (typeof JSON.parse(str) != "object") {
    return false;
  }

  return true;
};

export function PageComponent(props) {
  const classes = useStyles();

  const {
    templateDirectory,
    deviceDirectory,
    runCommandStartAction,
    onRequestTemplateDirectory,
    onRequestDeviceDirectory,
    templateDirLoading,
    deviceDirLoading,
  } = props;

  useEffect(() => {
    onRequestTemplateDirectory();
    onRequestDeviceDirectory();
  }, []);

  const [outVersion, setOutVersion] = React.useState<Directory>(null);
  const [formDevice, setFormDevice] = React.useState<Directory>(null);
  const [params, setParams] = React.useState("{}");

  const handleRunCommand = (event: any) => {
    if (!outVersion) {
      alert("Validation Error: `Версия выхода`");
      return;
    }
    if (!formDevice) {
      alert("Validation Error: `Контроллер`");
      return;
    }
    if (!isJsonObject(params)) {
      alert("Validation Error: `Параметры команды`");
      return;
    }

    console.log(outVersion, formDevice, params);

    runCommandStartAction(outVersion.id, formDevice.id, JSON.parse(params));
  };

  /* * */

  const handleChangeOutVersion = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    template: Directory
  ) => {
    setOutVersion(template);
    setParams("{}");
  };

  const handleChangeDevice = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    device: Directory
  ) => {
    setFormDevice(device);
  };

  const handleChangeParams = (params: string) => {
    console.log(">>>", params);
    setParams(params);
  };

  // ***

  const handleReset = (event: any) => {
    setParams("{}");
  };

  const getComponent = (id: number) => {
    const TagName = React.createElement(forms[id], {
      handleChange: handleChangeParams,
      value: params,
    });

    return TagName;
  };

  return (
    <>
      <Typography variant="h4" component="h1">
        Команды
      </Typography>

      <Accordion defaultExpanded>
        <AccordionDetails className={classes.commandContent}>
          <FormControl className={classes.formControl}>
            <Autocomplete
              id="device-box"
              options={templateDirectory.filter((item: Directory) => {
                return item.group === "command";
              })}
              getOptionLabel={(option: Directory) => option.title}
              getOptionSelected={(option: Directory, value: Directory) => {
                return option.id === value.id;
              }}
              disabled={templateDirLoading}
              limitTags={1}
              value={outVersion}
              onChange={handleChangeOutVersion}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Версия выхода"
                  variant="standard"
                  placeholder="Версия выхода"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {templateDirLoading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </FormControl>

          <FormControl className={classes.formControl}>
            <Autocomplete
              id="device-box"
              options={deviceDirectory}
              getOptionLabel={(option: Directory) =>
                "#" + option.id + " - " + option.title
              }
              getOptionSelected={(option: Directory, value: Directory) => {
                return option.id === value.id;
              }}
              disabled={deviceDirLoading}
              limitTags={1}
              value={formDevice}
              onChange={handleChangeDevice}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Контроллеры"
                  variant="standard"
                  placeholder="Контроллеры"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {deviceDirLoading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </FormControl>

          <Paper className={classes.paramsControl}>
            <Typography
              variant="h5"
              component="h3"
              className={classes.paramsTitle}
            >
              Параметры команды:
            </Typography>

            {outVersion && forms[outVersion.id] && (
              <>{getComponent(outVersion.id)}</>
            )}

            {(!outVersion || !forms[outVersion.id]) && (
              <CommandDefault
                value={params}
                handleChange={handleChangeParams}
              />
            )}
          </Paper>
        </AccordionDetails>

        <Divider />

        <AccordionActions>
          <Button onClick={handleReset} color="primary">
            Отменить
          </Button>

          <Button
            onClick={handleRunCommand}
            variant="contained"
            color="primary"
            disabled={
              deviceDirLoading ||
              deviceDirectory.length < 1 ||
              templateDirLoading ||
              templateDirectory.length < 1
            }
          >
            Выполнить
          </Button>
        </AccordionActions>
      </Accordion>
    </>
  );
}
